export default {
  props: {
    label: {
      type: String,
      required: true,
      default: '',
    },
    path: {
      type: String,
      required: true,
      default: 'name',
    },
    actionModule: {
      type: String,
      required: false,
      default: 'company',
    },
    actionName: {
      type: String,
      required: false,
      default: 'setValueWithPath',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Assurup',
    },
    debounceTimer: {
      type: Number,
      required: false,
      default: 700,
    },
  },
  data() {
    return {
      customValue: '',
      debouncer: ({ cancel: () => {} }),
    };
  },
  computed: {
    id() {
      return `${this.actionModule}-${this.path}`;
    },
    actionStore() {
      return `${this.actionModule}/${this.actionName}`;
    },
  },
};
